<template>
  <p class="clearfix mb-0 text-center">
    <span class="d-block d-md-inline-block mt-25">
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://inallar.com.tr/"
        target="_blank"
      >İnallar Otomotiv </b-link>
      <span class="d-none d-sm-inline-block"> Tüm hakları saklıdır.</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
